(() => {
  const start = () => {
    const data = document.querySelector('[data-bumpino-accessibility-labels]');
    if (!data) return;
    const labels = JSON.parse(data.textContent);
    const refresh = () => {
      for (const button of document.querySelectorAll('[aria-label="Previous"], [aria-label="Next"]')) {
        const label = button.getAttribute('aria-label') === 'Previous' ? labels.previous : labels.next;
        if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      }
    };
    refresh();
    new MutationObserver(refresh).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-label']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
